// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscription-management {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.subscription-management h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 24px;
}

.loading-state,
.error-state {
  text-align: center;
  padding: 60px 20px;
  font-size: 1.1rem;
  color: #6b7280;
}

.error-banner {
  background: #fee2e2;
  border: 1px solid #ef4444;
  color: #991b1b;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
}

/* Subscription Card */
.subscription-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.card-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  flex: 1 1;
}

.trial-badge {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.popular-badge {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.usage-period {
  font-size: 0.875rem;
  color: #6b7280;
}

/* Plan Details */
.plan-details {
  padding: 8px 0;
}

.plan-name-price {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 12px;
}

.plan-name-price h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #667eea;
  margin: 0;
}

.plan-price {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.plan-description {
  color: #6b7280;
  margin-bottom: 20px;
  line-height: 1.5;
}

.plan-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item.highlight {
  background: #fef3c7;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #fbbf24;
}

.info-label {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
}

.info-value {
  font-size: 1rem;
  color: #1f2937;
  font-weight: 600;
}

.status-trial {
  color: #3b82f6;
}

.status-active {
  color: #10b981;
}

.status-expired {
  color: #ef4444;
}

/* Usage Details */
.usage-details {
  padding: 8px 0;
}

.usage-stat {
  margin-bottom: 20px;
}

.stat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #667eea;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background: #e5e7eb;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  transition: width 0.3s ease;
}

.stat-info {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}

/* Features List */
.features-list {
  display: grid;
  gap: 12px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.feature-icon {
  color: #10b981;
  font-weight: 700;
  font-size: 1.25rem;
}

.feature-text {
  color: #374151;
  font-size: 0.95rem;
}

/* Actions */
.subscription-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-secondary {
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  background: #f3f4f6;
}

.btn-danger {
  background: #ef4444;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-danger:hover:not(:disabled) {
  background: #dc2626;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(239, 68, 68, 0.4);
}

.btn-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Cancellation Warning */
.cancellation-warning {
  background: #fef3c7;
  border: 2px solid #f59e0b;
  border-radius: 12px;
  padding: 20px;
  margin: 24px 0;
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.warning-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

.warning-content h4 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #92400e;
  margin: 0 0 8px 0;
}

.warning-content p {
  color: #78350f;
  margin: 0 0 16px 0;
  line-height: 1.6;
}

.warning-content .btn-secondary {
  background: white;
  color: #f59e0b;
  border-color: #f59e0b;
}

.warning-content .btn-secondary:hover {
  background: #fffbeb;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 16px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 2rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: #f3f4f6;
  color: #1f2937;
}

.billing-toggle {
  display: flex;
  gap: 12px;
  justify-content: center;
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
}

.toggle-btn {
  padding: 10px 20px;
  border: 2px solid #e5e7eb;
  background: white;
  color: #6b7280;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-btn:hover {
  border-color: #667eea;
  color: #667eea;
}

.toggle-btn.active {
  background: #667eea;
  color: white;
  border-color: #667eea;
}

.save-badge {
  background: #10b981;
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 700;
}

.plans-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  padding: 24px;
}

.plan-option {
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.plan-option:hover {
  border-color: #667eea;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.plan-option.selected {
  border-color: #667eea;
  background: #f9fafb;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.plan-option.popular {
  border-color: #f59e0b;
}

.popular-tag {
  position: absolute;
  top: -10px;
  right: 16px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
}

.plan-option h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.plan-price-modal {
  font-size: 1.75rem;
  font-weight: 800;
  color: #667eea;
  margin: 0 0 12px 0;
}

.plan-desc {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0 0 12px 0;
  line-height: 1.4;
}

.plan-limit {
  font-size: 0.95rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
  padding: 8px;
  background: #f3f4f6;
  border-radius: 6px;
  text-align: center;
}

.plan-features-modal {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.feature-mini {
  font-size: 0.85rem;
  color: #374151;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 20px 24px;
  border-top: 1px solid #e5e7eb;
}

/* Responsive */
@media (max-width: 768px) {
  .subscription-management {
    padding: 16px;
  }

  .subscription-management h2 {
    font-size: 1.5rem;
  }

  .plan-info-grid {
    grid-template-columns: 1fr;
  }

  .plan-name-price {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .plans-list {
    grid-template-columns: 1fr;
  }

  .modal-content {
    max-height: 95vh;
  }

  .billing-toggle {
    flex-direction: column;
  }

  .toggle-btn {
    width: 100%;
    justify-content: center;
  }
}

/* Cancel Modal Styles */
.cancel-modal {
  max-width: 600px;
}

.cancel-warning-box {
  text-align: center;
  padding: 24px;
}

.warning-icon-large {
  font-size: 4rem;
  margin-bottom: 16px;
}

.cancel-warning-box h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 16px 0;
}

.cancel-warning-box p {
  font-size: 1rem;
  color: #6b7280;
  margin: 0 0 12px 0;
  line-height: 1.6;
}

.cancel-details {
  background: #f9fafb;
  border-radius: 8px;
  padding: 20px;
  margin-top: 24px;
  text-align: left;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-label {
  font-weight: 500;
  color: #6b7280;
}

.detail-value {
  font-weight: 700;
  color: #1f2937;
}

.modal-footer {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  padding: 20px 24px;
  border-top: 1px solid #e5e7eb;
}

.modal-footer .btn-secondary,
.modal-footer .btn-danger {
  flex: 1 1;
  max-width: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionManagement.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,SAAO;AACT;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,SAAO;EACP,gBAAgB;AAClB","sourcesContent":[".subscription-management {\n  padding: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.subscription-management h2 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 24px;\n}\n\n.loading-state,\n.error-state {\n  text-align: center;\n  padding: 60px 20px;\n  font-size: 1.1rem;\n  color: #6b7280;\n}\n\n.error-banner {\n  background: #fee2e2;\n  border: 1px solid #ef4444;\n  color: #991b1b;\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n}\n\n/* Subscription Card */\n.subscription-card {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.card-header h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n  flex: 1;\n}\n\n.trial-badge {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.popular-badge {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.usage-period {\n  font-size: 0.875rem;\n  color: #6b7280;\n}\n\n/* Plan Details */\n.plan-details {\n  padding: 8px 0;\n}\n\n.plan-name-price {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-bottom: 12px;\n}\n\n.plan-name-price h2 {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #667eea;\n  margin: 0;\n}\n\n.plan-price {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0;\n}\n\n.plan-description {\n  color: #6b7280;\n  margin-bottom: 20px;\n  line-height: 1.5;\n}\n\n.plan-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.info-item.highlight {\n  background: #fef3c7;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #fbbf24;\n}\n\n.info-label {\n  font-size: 0.875rem;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.info-value {\n  font-size: 1rem;\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.status-trial {\n  color: #3b82f6;\n}\n\n.status-active {\n  color: #10b981;\n}\n\n.status-expired {\n  color: #ef4444;\n}\n\n/* Usage Details */\n.usage-details {\n  padding: 8px 0;\n}\n\n.usage-stat {\n  margin-bottom: 20px;\n}\n\n.stat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.stat-label {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.stat-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #667eea;\n}\n\n.progress-bar {\n  width: 100%;\n  height: 12px;\n  background: #e5e7eb;\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 8px;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  transition: width 0.3s ease;\n}\n\n.stat-info {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin: 0;\n}\n\n/* Features List */\n.features-list {\n  display: grid;\n  gap: 12px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.feature-icon {\n  color: #10b981;\n  font-weight: 700;\n  font-size: 1.25rem;\n}\n\n.feature-text {\n  color: #374151;\n  font-size: 0.95rem;\n}\n\n/* Actions */\n.subscription-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n.btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: white;\n  color: #667eea;\n  border: 2px solid #667eea;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-secondary:hover {\n  background: #f3f4f6;\n}\n\n.btn-danger {\n  background: #ef4444;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #dc2626;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(239, 68, 68, 0.4);\n}\n\n.btn-danger:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Cancellation Warning */\n.cancellation-warning {\n  background: #fef3c7;\n  border: 2px solid #f59e0b;\n  border-radius: 12px;\n  padding: 20px;\n  margin: 24px 0;\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n}\n\n.warning-icon {\n  font-size: 2rem;\n  flex-shrink: 0;\n}\n\n.warning-content h4 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #92400e;\n  margin: 0 0 8px 0;\n}\n\n.warning-content p {\n  color: #78350f;\n  margin: 0 0 16px 0;\n  line-height: 1.6;\n}\n\n.warning-content .btn-secondary {\n  background: white;\n  color: #f59e0b;\n  border-color: #f59e0b;\n}\n\n.warning-content .btn-secondary:hover {\n  background: #fffbeb;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 16px;\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.modal-close:hover {\n  background: #f3f4f6;\n  color: #1f2937;\n}\n\n.billing-toggle {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  padding: 20px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.toggle-btn {\n  padding: 10px 20px;\n  border: 2px solid #e5e7eb;\n  background: white;\n  color: #6b7280;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.toggle-btn:hover {\n  border-color: #667eea;\n  color: #667eea;\n}\n\n.toggle-btn.active {\n  background: #667eea;\n  color: white;\n  border-color: #667eea;\n}\n\n.save-badge {\n  background: #10b981;\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.plans-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 16px;\n  padding: 24px;\n}\n\n.plan-option {\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 20px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.plan-option:hover {\n  border-color: #667eea;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);\n}\n\n.plan-option.selected {\n  border-color: #667eea;\n  background: #f9fafb;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.plan-option.popular {\n  border-color: #f59e0b;\n}\n\n.popular-tag {\n  position: absolute;\n  top: -10px;\n  right: 16px;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.plan-option h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0 0 8px 0;\n}\n\n.plan-price-modal {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #667eea;\n  margin: 0 0 12px 0;\n}\n\n.plan-desc {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin: 0 0 12px 0;\n  line-height: 1.4;\n}\n\n.plan-limit {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 12px;\n  padding: 8px;\n  background: #f3f4f6;\n  border-radius: 6px;\n  text-align: center;\n}\n\n.plan-features-modal {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.feature-mini {\n  font-size: 0.85rem;\n  color: #374151;\n}\n\n.modal-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding: 20px 24px;\n  border-top: 1px solid #e5e7eb;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .subscription-management {\n    padding: 16px;\n  }\n\n  .subscription-management h2 {\n    font-size: 1.5rem;\n  }\n\n  .plan-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .plan-name-price {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .plans-list {\n    grid-template-columns: 1fr;\n  }\n\n  .modal-content {\n    max-height: 95vh;\n  }\n\n  .billing-toggle {\n    flex-direction: column;\n  }\n\n  .toggle-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* Cancel Modal Styles */\n.cancel-modal {\n  max-width: 600px;\n}\n\n.cancel-warning-box {\n  text-align: center;\n  padding: 24px;\n}\n\n.warning-icon-large {\n  font-size: 4rem;\n  margin-bottom: 16px;\n}\n\n.cancel-warning-box h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1f2937;\n  margin: 0 0 16px 0;\n}\n\n.cancel-warning-box p {\n  font-size: 1rem;\n  color: #6b7280;\n  margin: 0 0 12px 0;\n  line-height: 1.6;\n}\n\n.cancel-details {\n  background: #f9fafb;\n  border-radius: 8px;\n  padding: 20px;\n  margin-top: 24px;\n  text-align: left;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 0;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.detail-item:last-child {\n  border-bottom: none;\n}\n\n.detail-label {\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.detail-value {\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.modal-footer {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  padding: 20px 24px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.modal-footer .btn-secondary,\n.modal-footer .btn-danger {\n  flex: 1;\n  max-width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
